/**
 * Define the a core resource for the model, this interface shall be
 * used as a base class for every other core entity/object.
 *
 * @deprecated This interface is deprecated and all models should be refactored
 * to use {@link Entity} instead.
 */
export class CoreResource {
    /**
     * Types used by core model. Single resource can be of multiple
     * application types like PimClass, PimAttribute, etc..
     */
    types = [];
    /**
     * In order to allow identification of all resources they must all use
     * named nodes. Blank nodes are not allowed. This property can
     * be set to null for new objects.
     */
    iri;
    constructor(iri) {
        this.iri = iri;
    }
}
export function coreResourceToEntity(resource) {
    return {
        ...resource,
        id: resource.iri,
        type: resource.types,
    };
}
//# sourceMappingURL=core-resource.js.map